
import request from '../ajax_request.js'
import {base_url,debug_obj} from "../base_api"




export function lookup_cash_withdraw(query){
	let def_base_url = base_url + "/pos";
	let url = `${def_base_url}/cash`;
	return request({
        url,
        method: 'get',
        params:Object.assign({},debug_obj,query?query:{})
    })
}

export function create_cash_withdraw({params,data}){
	let  def_base_url =  base_url+ '/pos'

	let url = `${def_base_url}/cash`;
	debugger
	return request({
		url,
		method : 'post',
		// params :{oper:type},
		params:Object.assign({},debug_obj,params?params:{}),
		data
    })
}






// WEBPACK FOOTER //
// ./src/api/module/shop_cash.js